module.exports = __webpack_public_path__ + "static/img/COC2023-9.63045c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-9.png
// module id = Nkqu
// module chunks = 0